// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-dialog-container {
  display: flex;
  width: 100%;
  height: auto;
  max-height: 90vh;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.media-wrapper {
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.media-image {
  display: block;
  width: 100%;
  height: auto;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 4px;
}

.media-video {
  display: block;
  width: 100%;
  height: auto;
  max-height: 85vh;
  outline: none;
  border-radius: 4px;
  background: #000;
}

@media (min-width: 1200px) {
  .media-wrapper {
    max-width: 1100px;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .media-wrapper {
    max-width: calc(100vw - 64px);
    padding: 0;
  }
  .media-image,
  .media-video {
    max-height: 82vh;
  }
}
@media (min-width: 600px) and (max-width: 767px) {
  .media-wrapper {
    max-width: calc(100vw - 48px);
  }
  .media-image,
  .media-video {
    max-height: 80vh;
  }
}
@media (max-width: 599px) {
  .media-wrapper {
    max-width: calc(100vw - 24px);
  }
  .media-image,
  .media-video {
    max-height: 78vh;
  }
}
::ng-deep .mat-mdc-dialog-container.media-dialog,
::ng-deep .cdk-overlay-pane.media-dialog-pane {
  max-width: 100vw !important;
  max-height: 100vh !important;
  width: auto !important;
  height: auto !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

::ng-deep .mat-mdc-dialog-surface.media-dialog-surface {
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/show-flow-image-dialog/show-flow-image-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAGA;EACE;IACE,iBAAA;EAAF;AACF;AAIA;EACE;IACE,6BAAA;IACA,UAAA;EAFF;EAKA;;IAEE,gBAAA;EAHF;AACF;AAOA;EACE;IACE,6BAAA;EALF;EAQA;;IAEE,gBAAA;EANF;AACF;AAUA;EACE;IACE,6BAAA;EARF;EAWA;;IAEE,gBAAA;EATF;AACF;AAaA;;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AAXF;;AAcA;EACE,qBAAA;EACA,oBAAA;EACA,kCAAA;EACA,2BAAA;AAXF","sourcesContent":[".media-dialog-container {\n  display: flex;\n  width: 100%;\n  height: auto;\n  max-height: 90vh;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.media-wrapper {\n  width: 100%;\n  max-width: 900px;\n  max-height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.media-image {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 85vh;\n  object-fit: contain;\n  border-radius: 4px;\n}\n\n.media-video {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 85vh;\n  outline: none;\n  border-radius: 4px;\n  background: #000;\n}\n\n// Desktop large screens\n@media (min-width: 1200px) {\n  .media-wrapper {\n    max-width: 1100px;\n  }\n}\n\n// Tablets\n@media (min-width: 768px) and (max-width: 1023px) {\n  .media-wrapper {\n    max-width: calc(100vw - 64px);\n    padding: 0;\n  }\n\n  .media-image,\n  .media-video {\n    max-height: 82vh;\n  }\n}\n\n// Medium tablets and large phones\n@media (min-width: 600px) and (max-width: 767px) {\n  .media-wrapper {\n    max-width: calc(100vw - 48px);\n  }\n\n  .media-image,\n  .media-video {\n    max-height: 80vh;\n  }\n}\n\n// Small phones\n@media (max-width: 599px) {\n  .media-wrapper {\n    max-width: calc(100vw - 24px);\n  }\n\n  .media-image,\n  .media-video {\n    max-height: 78vh;\n  }\n}\n\n// Material dialog container adjustments for this dialog\n::ng-deep .mat-mdc-dialog-container.media-dialog,\n::ng-deep .cdk-overlay-pane.media-dialog-pane {\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  width: auto !important;\n  height: auto !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n::ng-deep .mat-mdc-dialog-surface.media-dialog-surface {\n  padding: 0 !important;\n  margin: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
